import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { TrackingConstant } from 'client/tracking/constant';
import { EventToolbox } from 'client/utils/event-toolbox';
import { IcoWidgetAsync } from 'client/site-modules/shared/components/dealer-ico-widget/ico-widget/ico-widget-async';
import {
  ICO_ON_EDMUNDS_CREATIVE_IDS,
  ICO_WIDGET_DISPLAY_TYPES,
} from 'client/site-modules/shared/components/dealer-ico-widget/constants';
import {
  DealerIcoWidgetEntities,
  DealerIcoWidgetModel,
  buildDealerIcoWidgetConfigurationPath,
} from 'client/data/models/dealer-ico-widget';
import './ico-reduced-height-standard.scss';

export const IcoReducedHeightStandardUI = ({
  dealerId = null,
  icoWidgetConfig = {},
  IcoWidgetComponent = IcoWidgetAsync,
  decreaseTitle = false,
}) => {
  useEffect(() => {
    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
      event_data: {
        creative_id: ICO_ON_EDMUNDS_CREATIVE_IDS.REDUCED_HEIGHT_STANDARD_EDMUNDS,
        action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
        action_cause: TrackingConstant.PAGE_LOAD_CAUSE,
        action_name: TrackingConstant.ACTION_SHOW_CONTENT,
        subaction_name: TrackingConstant.SUBACTION_ICO_DEALER,
        value: !!dealerId && get(icoWidgetConfig, 'isActive', false),
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hasIco = !!dealerId && get(icoWidgetConfig, 'isActive', false);
  return (
    !!hasIco && (
      <div
        className={classnames({ 'ico-widget-container': hasIco }, 'd-flex justify-content-center')}
        data-tracking-parent={TrackingConstant.CREATIVE_ID_EDM_ENTRY_ICO_REDUCED_HEIGHT_STANDARD_EDMUNDS}
      >
        <div className={classnames({ 'ico-title-decrease': decreaseTitle }, 'ico-widget-centered w-100')}>
          <IcoWidgetComponent
            dealerId={dealerId}
            displayType={ICO_WIDGET_DISPLAY_TYPES.REDUCED_HEIGHT_STANDARD_EDMUNDS}
            injectInitializationScriptOnMount
            showSpinner={false}
          />
        </div>
      </div>
    )
  );
};

IcoReducedHeightStandardUI.propTypes = {
  dealerId: PropTypes.string.isRequired,
  icoWidgetConfig: DealerIcoWidgetEntities.Configs,
  IcoWidgetComponent: PropTypes.elementType,
  decreaseTitle: PropTypes.bool,
};

export const stateToPropsConfig = {
  icoWidgetConfig: bindToPath(
    ({ dealerId }) => buildDealerIcoWidgetConfigurationPath({ rooftopId: dealerId }),
    DealerIcoWidgetModel
  ),
};

export const IcoReducedHeightStandard = connectToModel(IcoReducedHeightStandardUI, stateToPropsConfig);

IcoReducedHeightStandard.propTypes = {
  ...IcoReducedHeightStandardUI.propTypes,
};
